import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';

let connection = null;

export function buildConnection() {
    
  var url = 'http://matchapi.jianyuesports.com/scoreHub'; // 线上环境
  if (location.href.indexOf('jianyuesports.com') == -1){
    url = 'http://localhost:5160/scoreHub'; // 测试环境
  }
  connection = new HubConnectionBuilder()
    .withUrl(url)
    .withAutomaticReconnect()
    .configureLogging(LogLevel.Information)
    .build();
  return connection;
}

export function getConnection() {
  return connection;
}